module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--1-d7f2d22e1a9c2b0ab480927f30931cb7.jpg";